import React, { memo } from "react"
import { graphql } from "gatsby"

import ReferenceLayout from "~layouts/ReferenceLayout"

import Resource from "~components/Resource"
import Head from "~components/Head"

const ReferenceResource = ({ data, location, pageContext }) => (
  <ReferenceLayout location={location}>
    <Head title={pageContext.title} />
    <Resource resource={data.resource} />
  </ReferenceLayout>
)

export default memo(ReferenceResource)

export const paramFields = graphql`
  fragment paramFields on Param {
    id
    type
    types
    key
    format
    anchor
    enum
    example
    default
    minValue
    maxValue
    maxLength
    itemType
    pattern
    showDescription
    descriptionAst
    hasAdditionalProperties
    parentParamId
    resource {
      id
      path
      title
      hasVariants
    }
    resources {
      id
      path
      title
      hasVariants
    }
  }
`

export const query = graphql`
  query($id: String!) {
    resource(id: { eq: $id }) {
      id
      version
      key
      descriptionAst
      hasVariants
      variant
      variants
      resourceGroup
      jsonExample
      title
      reportErrorFormUrl
      path
      params {
        ...paramFields
        params {
          ...paramFields
          params {
            ...paramFields
            params {
              ...paramFields
            }
          }
        }
      }
    }
  }
`
